import { useMemo, useEffect } from 'react'
import { useRouter } from 'next/router'

//* HOCs
import { withDataContext } from 'context'

//* Helpers
import { makeColor } from 'helpers/_colorMaker'

//* Components
import { Text, ButtonTag, Image } from 'components/common'
import ProfileDebates from '../ProfileDebates'

const ProfileRightBar = ({ profile: { id, bio, skills, interests }, isMyProfile, ...props }) => {
    const router = useRouter()

    const storeInterests = useMemo(() => {
        return interests?.map((i) => (
            <ButtonTag
                bgColor={makeColor()}
                onClick={() => router.push(`/search?s=${i.name}`)}
                key={i.id}
                content={i.name}
            />
        ))
    }, [interests])

    const storeSkills = useMemo(() => {
        return skills?.map((i) => (
            <ButtonTag
                key={i.id}
                cssClass='black'
                content={i.name}
            />
        ))
    }, [skills])

    useEffect(() => {
        props.getProfileDebates({
            isMyProfile,
            userId: id,
            sortBy: 'DESC',
            type: 'debates'
        })
    }, [id, isMyProfile])

    return (
        <div className='right flexBoxColumn'>
            {!bio
                && !isMyProfile
                && skills?.length === 0
                && interests?.length === 0
                && props.checkHasProfileDebates()
                &&
                <>
                    <Image className='not-found' src='/images/notFound.gif' />
                    <Text tag={'h3'} className='not-found-text PopReg h4' text='This user is searching for inspiration in the space.' />
                </>
            }
            {bio && (
                <div className='bio flexBoxColumn single-block'>
                    <Text tag={'p'} className={'PopSemi h9'} text={'Biography'} />
                    <Text tag={'p'} className={'btn-block PopReg h5'} text={bio} />
                </div>
            )}

            {skills?.length > 0 && (
                <div className='skills flexBoxColumn single-block'>
                    <Text tag={'p'} className={'PopSemi h9'} text={'Skills'} />
                    <div className='skills-block btn-block flexBox'>{storeSkills}</div>
                </div>
            )}
            {interests?.length > 0 && (
                <div className='interests flexBoxColumn single-block'>
                    <Text tag={'p'} className={'PopSemi h9'} text={'Topics of Interests'} />
                    <div className='interests-block btn-block flexBox'>
                        {storeInterests}
                    </div>
                </div>
            )}

            {((!isMyProfile && !props.checkHasProfileDebates()) || isMyProfile) && (
                <ProfileDebates
                    profileId={id}
                    isMyProfile={isMyProfile}
                />
            )}
        </div>
    )
}

export default withDataContext(ProfileRightBar, ['getProfileDebates', 'checkHasProfileDebates'])